import { makeStyles } from '@material-ui/styles';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { LoadingState } from 'ui';
import Theme from '../../../../theme/login-theme';
import { SvgIcon } from '../../../components/icons/svg-icon';
import Loading from '../../../components/loading';
import { PreviewsPane } from '../../../components/slider/slider';
import { useLoginDispatch } from '../../../store';
import { getTranslates } from '../../../store/language-select/selectors';
import { resetTimer, showNextNewsImage, showPrevNewsImage } from '../../../store/news/actions';
import { getBackgroundImagePath } from '../../../store/news/entities';
import { getCurrentNewsIndex, getIntervalId, getLoadingNews, getNewsView } from '../../../store/news/selectors';

const createStyles = makeStyles((theme: Theme) => ({
    contentBlock: theme.custom?.content.contentBlock || {},
    contentLeft: theme.custom?.content.contentLeft || {},
    contentLeftNotNav: theme.custom?.content.contentLeftNotNav || {},
    contentCenter: theme.custom?.content.contentCenter || {},
    contentRight: theme.custom?.content.contentRight || {},
    contentRighNotNav: theme.custom?.content.contentRighNotNav || {},
    description: theme.custom?.content.description || {},
    imageList: theme.custom?.content.imageList || {},
    nextButton: theme.custom?.content.nextButton || {},
    prevButton: theme.custom?.content.prevButton || {},
    descriptionTitle: theme.custom?.content.descriptionTitle || {},
    descriptionText: theme.custom?.content.descriptionText || {},
    descriptionLink: theme.custom?.content.descriptionLink || {},
    descriptionLinkColor: theme.custom?.content.descriptionLinkColor || {},
    previewList: theme.custom?.content.previewList || {},
}));

export const Content: React.FC = () => {
    const dispatch = useLoginDispatch();
    const classes = createStyles();
    const isNewsLoading = useSelector(getLoadingNews);
    const newsView = useSelector(getNewsView);
    const currentNewsIndex = useSelector(getCurrentNewsIndex);
    const currentNews = newsView[currentNewsIndex];
    let translations = useSelector(getTranslates);
    let intervalId = useSelector(getIntervalId);

    let backgroundImage = '';
    let windowWidth = window.innerWidth;

    backgroundImage = getBackgroundImagePath(windowWidth, currentNews);

    const preparedText = currentNews?.body.map((text: string, index: number) => {
        return (
            <React.Fragment key={index}>
                <div dangerouslySetInnerHTML={{ __html: text }} />
                <br />
            </React.Fragment>
        );
    });

    const onPressNextButton = React.useCallback(() => {
        dispatch(showNextNewsImage());
        dispatch(resetTimer());
    }, [intervalId]);

    const onPressPrevButton = React.useCallback(() => {
        dispatch(showPrevNewsImage());
        dispatch(resetTimer());
    }, [intervalId]);

    if (isNewsLoading === LoadingState.InProgress) {
        return <Loading />;
    }

    if (!newsView.length) {
        return (
            <div
                className={classes.contentBlock}
                style={{
                    backgroundImage: `url(/img/login_backimage.png)`,
                }}
            />
        );
    }

    return (
        <div
            className={classes.contentBlock}
            style={{
                backgroundImage: `url("${backgroundImage}")`,
            }}
        >
            {newsView.length > 1 ? (
                <div className={classes.contentLeft} onClick={onPressPrevButton}>
                    <div className={classes.prevButton}>
                        <SvgIcon type="chevron-left" />
                    </div>
                </div>
            ) : (
                <div className={classes.contentLeftNotNav} />
            )}
            <div className={classes.contentCenter}>
                <div className={classes.description}>
                    <div className={classes.descriptionTitle}>{currentNews?.caption}</div>
                    <div className={classes.descriptionText}>{preparedText}</div>
                </div>
                <div className={classes.imageList}>
                    <div className={classes.descriptionLink}>
                        {currentNews?.link !== '' && (
                            <a
                                href={currentNews?.link}
                                rel="noreferrer"
                                target="_blank"
                                className={classes.descriptionLinkColor}
                            >
                                {translations.MoreDetails}
                            </a>
                        )}
                    </div>
                    {isNewsLoading === LoadingState.Success && newsView.length > 1 && (
                        <div className={classes.previewList}>
                            <PreviewsPane newsView={newsView} />
                        </div>
                    )}
                    {isNewsLoading === LoadingState.Failure && (
                        <div className={classes.previewList}>
                            <p>Не удалось загрузить медиа файлы</p>
                        </div>
                    )}
                </div>
            </div>
            {newsView.length > 1 ? (
                <div className={classes.contentRight} onClick={onPressNextButton}>
                    <div className={classes.nextButton}>
                        <SvgIcon type="chevron-right" />
                    </div>
                </div>
            ) : (
                <div className={classes.contentRighNotNav} />
            )}
        </div>
    );
};
